<template>
  <div
    v-if="$store.state.zoom.showImg != null"
    class="crpg-o-common-zoom-image"
    @click="close"
  >
    <MoleculesCommonZoomImage />
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/css/organisms/common/zoomImage.scss";
</style>

<script>
import MoleculesCommonZoomImage from "@/components/molecules/common/ZoomImage.vue";

export default {
  name: "OrganismsCommonZoomImage",
  components: {
    MoleculesCommonZoomImage,
  },
  props: {
    image: {
      String: "",
    },
  },
  methods: {
    close() {
      /**
       * 画像クリック時はクローズ無効
       */
      this.$store.dispatch("zoom/hide", [null, ""]);
    },
  },
};
</script>
